/**
 * Where the PROduce Crew app lives, in one place.
 *
 * Crew work exclusively in the native app — the browser only ever points
 * them at it — so these two URLs turn up on the marketing banner and on the
 * "get the app" page. One constant means a store listing can move without
 * anyone hunting for the second copy.
 */
export const APP_STORE_URL = "https://apps.apple.com/nl/app/produce-crew/id6761206384";
export const PLAY_STORE_URL = "https://play.google.com/store/apps/details?id=com.produce.crew";

export type MobilePlatform = "ios" | "android" | "other";

/**
 * Cheap user-agent sniff, good enough to send a phone straight to its own
 * store. Anything that isn't obviously a phone is treated as "other" and
 * shown both badges, so being wrong costs a visitor nothing.
 */
export function detectMobilePlatform(userAgent?: string): MobilePlatform {
  const ua = userAgent ?? (typeof navigator === "undefined" ? "" : navigator.userAgent || "");
  if (/iPhone|iPad|iPod/i.test(ua)) return "ios";
  if (/Android/i.test(ua)) return "android";
  return "other";
}
